import { render, staticRenderFns } from "./NodePricing.vue?vue&type=template&id=c328c134&"
import script from "./NodePricing.vue?vue&type=script&lang=js&"
export * from "./NodePricing.vue?vue&type=script&lang=js&"
import style0 from "./NodePricing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports